// Window event re-broadcasting a SignalR `NotificationAdded` payload to UI
// listeners (mirrors the Vue `$notificationHub.$emit('notification-added')`).
// Defined in the notification module; re-exported here for component consumers.
export { NOTIFICATION_ADDED_EVENT } from '../../../modules/notification';

// Storage key prefix used to suppress an already-dismissed real-time toast.
export const SEEN_PREFIX = 'notification-seen-';
export const SEEN_DAYS = 7;

// Auto-dismiss delay (ms) for a real-time toast. 0 disables auto-dismiss.
export const TOAST_AUTO_DISMISS_MS = 8000;
